import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// TODO:Spartacus - 'OccSitesConfigLoader has been removed and is no longer part of the public API. Please use 'SiteContextConfigInitializer' and 'I18nConfigInitializer' instead
import { BaseSite, Occ, OccConfig, SiteAdapter, SiteConnector } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Extent the OccSitesConfigLoader to be able to get the storeUid, and other custom params if needed.
 */
@Injectable({ providedIn: 'root' })
export class CustomOccSitesConfigLoader extends SiteConnector {
  constructor(protected config: OccConfig, protected http: HttpClient, protected adapter: SiteAdapter) {
    super(adapter);
  }

  // add "storeUid" in basesites api to retrieve from BE API
  protected readonly customendpoint =
    'basesites?fields=baseSites(uid,defaultLanguage(isocode),urlEncodingAttributes,urlPatterns,stores(currencies(isocode),defaultCurrency(isocode),languages(isocode),defaultLanguage(isocode)),theme,defaultPreviewCatalogId,defaultPreviewCategoryCode,defaultPreviewProductCode)';
  private getCustomPrefix(): string {
    if (Boolean(this.config.backend?.occ?.prefix) && !this.config.backend?.occ?.prefix?.startsWith('/')) {
      return '/' + this.config.backend.occ.prefix;
    }
    return this.config.backend.occ.prefix;
  }

  private get customBaseEndpoint(): string {
    return (this.config.backend.occ.baseUrl || '') + this.getCustomPrefix();
  }

  private get customUrl(): string {
    return `${this.customBaseEndpoint}${this.customendpoint}`;
  }

  load(): Observable<BaseSite[]> {
    if (!this.config || !this.config.backend || !this.config.backend.occ) {
      return throwError(new Error(`Missing config for OCC backend!`));
    }

    return this.http.get<Occ.BaseSites>(this.customUrl).pipe(map(({ baseSites }) => baseSites));
  }
}
